import React, { Fragment, useCallback, useContext, useEffect, useRef, useState } from 'react'

import { Button } from '@nextui-org/button'
import Image from 'next/image'
import { Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, useDisclosure } from '@nextui-org/modal'

import iconPostAdd from '@/assets/icons/post_add.svg'
import ICONS from '@/assets/icons'
import { ImplementPostProvider } from '@/app/(global)/post-cre/components/RenderFormFeed'
import {
  PostContext,
  TextareaPost,
  TextareaPostProvider,
} from '@/app/(global)/post-cre/components/TextareaPostProvider'
import EmojiPost from '@/app/(global)/feed/components/Emoji'
import useIsMobile from '@/hooks/useIsMobile'

const PostModal = () => {
  const { isCompleted } = useContext(PostContext) || {}
  const { isOpen, onOpen, onOpenChange, onClose } = useDisclosure()
  const inputFileRef = useRef<HTMLInputElement>(null)
  const [isOpenEmj, setIsOpen] = useState<boolean>(false)
  const { setImages, setMetadata, setTextPost } = useContext(PostContext)
  const isMobile = useIsMobile()

  useEffect(() => {
    if (isCompleted) {
      onClose()
    }
  }, [isCompleted])

  const handleClearImage = useCallback(() => {
    if (inputFileRef.current) {
      inputFileRef.current.value = ''
    }
  }, [inputFileRef])
  return (
    <Fragment>
      <div className="fixed bottom-[72px] right-6 z-30 max-w-[628px] lg:hidden">
        <div className="rounded-full">
          <Button
            id="post-mb"
            onPress={onOpen}
            className="z-40 flex h-[60px] w-[60px] min-w-10 cursor-pointer items-center rounded-full bg-ss-primary text-[12px] font-semibold text-secondary lg:hidden"
          >
            <Image src={iconPostAdd} alt="" width={17} height={17} className="size-[24px] object-cover" />
          </Button>
        </div>
      </div>
      <Modal
        classNames={{
          base: 'h-[100%] max-h-[100%]',
        }}
        className="bg-ss-dark text-white"
        size="2xl"
        hideCloseButton
        isOpen={isOpen}
        scrollBehavior={'inside'}
        onOpenChange={onOpenChange}
        // scrollBehavior="inside"
      >
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex items-center justify-between border-b border-white/10">
                <div className="flex items-center gap-6  ">
                  <Image
                    onClick={onClose}
                    className="cursor-pointer"
                    src={ICONS.icCloseWhite}
                    width={22}
                    height={22}
                    alt=""
                  />
                  <h3 className="text-base font-medium text-white">Create post</h3>
                </div>

                {isMobile && <ImplementPostProvider onTonggleModal={onClose} />}
              </ModalHeader>
              <ModalBody className="py-4 text-white">
                <TextareaPost type="post" isMobile clearDataImage={handleClearImage}>
                  <ImplementPostProvider />
                </TextareaPost>
              </ModalBody>
              <ModalFooter>
                <div className="flex w-full items-center justify-between">
                  <ul className="flex items-center gap-x-4">
                    <li className="cursor-pointer" onClick={() => inputFileRef.current?.click()}>
                      <Image src={ICONS.addImage} width={20} height={20} alt="Add Image" />
                      <input
                        multiple
                        type="file"
                        // onChange={handleImageUpload}
                        onChange={(e) => {
                          setImages((prev: any[]) => [...prev, ...(e.target.files as any)])

                          if (e.target.files?.length) {
                            setMetadata(null)
                          }
                        }}
                        ref={inputFileRef}
                        style={{ display: 'none' }}
                        accept=".png,.svg,.jpg,.jpeg"
                      />
                    </li>
                    <li className="relative cursor-pointer">
                      <EmojiPost
                        onSelectIcon={(emoji) => {
                          setTextPost((prev: string) => prev + emoji)
                        }}
                        isOpen={isOpenEmj}
                        onToggleOpen={() => setIsOpen(!isOpen)}
                        position={'top'}
                      />
                      <Image
                        onClick={(e) => {
                          e.stopPropagation()
                          setIsOpen((prev) => !prev)
                        }}
                        src={ICONS.emoji}
                        width={20}
                        height={20}
                        alt="Emoji"
                      />
                    </li>
                  </ul>
                  {!isMobile && <ImplementPostProvider />}
                </div>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </Fragment>
  )
}

function PostAddMB() {
  return (
    <TextareaPostProvider>
      <PostModal />
    </TextareaPostProvider>
  )
}

export default PostAddMB
